import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CustomerTableRow = ({ customer, onViewDetails, onQuickAction }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'bg-success/10 text-success';
      case 'Inactive':
        return 'bg-muted text-muted-foreground';
      case 'Pending':
        return 'bg-warning/10 text-warning';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <tr className="border-b border-border hover:bg-muted/50 transition-smooth">
      <td className="px-4 md:px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <div className="font-medium text-foreground truncate">{customer?.name}</div>
            <div className="text-sm text-muted-foreground truncate">{customer?.email}</div>
          </div>
        </div>
      </td>
      <td className="px-4 md:px-6 py-4 hidden lg:table-cell">
        <div className="text-foreground">{customer?.company}</div>
      </td>
      <td className="px-4 md:px-6 py-4 hidden md:table-cell">
        <div className="text-foreground">{customer?.phone}</div>
      </td>
      <td className="px-4 md:px-6 py-4 hidden xl:table-cell">
        <div className="text-foreground">{customer?.location}</div>
      </td>
      <td className="px-4 md:px-6 py-4 hidden lg:table-cell">
        <div className="text-foreground">{formatDate(customer?.lastService)}</div>
      </td>
      <td className="px-4 md:px-6 py-4">
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(customer?.status)}`}>
          {customer?.status}
        </span>
      </td>
      <td className="px-4 md:px-6 py-4">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onViewDetails(customer)}
            className="hidden md:flex"
          >
            <Icon name="Eye" size={18} color="var(--color-foreground)" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onQuickAction(customer, 'message')}
            className="hidden lg:flex"
          >
            <Icon name="MessageSquare" size={18} color="var(--color-foreground)" />
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onViewDetails(customer)}
            className="md:hidden"
          >
            View
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default CustomerTableRow;